import { createContext, useCallback, useContext, useState, type ReactNode } from "react";
import QuizModal from "@/components/feature/QuizModal";
import { askAiWidget, openAiWidget } from "@/lib/aiWidget";

type UiContextValue = {
  openQuiz: () => void;
  openAi: () => void;
  askAi: (question: string) => void;
};

const UiContext = createContext<UiContextValue>({
  openQuiz: () => {},
  openAi: () => {},
  askAi: () => {},
});

export function UiProvider({ children }: { children: ReactNode }) {
  const [quizOpen, setQuizOpen] = useState(false);

  const openQuiz = useCallback(() => setQuizOpen(true), []);
  const openAi = useCallback(() => openAiWidget(), []);
  const askAi = useCallback((question: string) => {
    void askAiWidget(question);
  }, []);
  const closeQuiz = useCallback(() => setQuizOpen(false), []);

  return (
    <UiContext.Provider value={{ openQuiz, openAi, askAi }}>
      {children}
      <QuizModal open={quizOpen} onClose={closeQuiz} onOpenAi={openAi} />
    </UiContext.Provider>
  );
}

export function useUi() {
  return useContext(UiContext);
}